import { render, staticRenderFns } from "./BoardCheckout.vue?vue&type=template&id=d2660d0e&scoped=true&"
import script from "./BoardCheckout.vue?vue&type=script&lang=js&"
export * from "./BoardCheckout.vue?vue&type=script&lang=js&"
import style0 from "./BoardCheckout.vue?vue&type=style&index=0&id=d2660d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2660d0e",
  null
  
)

export default component.exports